import { apiSlice } from '../../app/api/apiSlice';
import { Order } from '../../types/order';
import { UpdateOrderStatusBody } from '../../types/request';
import { GetAllOrderResponse, GetOrderByIdResponse, OrderUpdateResponse } from '../../types/response';

export const orderApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllOrder: builder.query<Order[], void>({
            query: () => `/api/orders/all`,
            transformResponse: (response: GetAllOrderResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Orders', id: 'LIST' }],
        }),

        getOrderById: builder.query<Order, number>({
            query: (orderId) => `/api/orders/order/${orderId}`,
            transformResponse: (response: GetOrderByIdResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: (result, error, orderId ) => [
                { type: 'Orders', id: 'LIST' },
                { type: 'Orders', id: orderId },
            ],
        }),

        // updateOrderStatus
        updateStatusOrder: builder.mutation<OrderUpdateResponse, { orderId: number; body: UpdateOrderStatusBody}>({
            query: ({ orderId, body }) => ({
                url: `/api/orders/status/${orderId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { orderId } ) => [
                { type: 'Orders', id: 'LIST' },
                { type: 'Orders', id: orderId },
            ],
        }),
        // cancelOrderBySession
        cancelledOrderStatus: builder.mutation<OrderUpdateResponse, number>({
            query: (orderId) => ({
                url: `/api/orders/status/cancel/${orderId}`,
                method: 'PUT',
            }),
            invalidatesTags: (result, error, orderId ) => [
                { type: 'Orders', id: 'LIST' },
                { type: 'Orders', id: orderId },
            ],
        }),
    }),
});

export const { 
    useGetAllOrderQuery,
    useGetOrderByIdQuery,
    useUpdateStatusOrderMutation,
    useCancelledOrderStatusMutation,
} = orderApiSlice;